const Categories = require('../model/Categories');
const ChannelDefinition = require('../model/ChannelDefinition');
const Requirements = require('../model/Requirements');

class StorefrontChannel extends ChannelDefinition {
	id = 'storefront';
	title = 'Storefront';
	description = 'Your NearSt-hosted storefront for showcasing products and store information.';
	category = Categories.OMNICHANNEL_EXPERIENCE;

	iconUrl = 'https://images.near.st/channels/nearst.png';
	coverImageUrl = 'https://images.near.st/channels/headers/shop-page.png';

	longDescription = `
## Overview
The Storefront upgrades your NearSt shop page with searchable product categories and full-text product search, making it easier for customers to discover and browse your products.

## How it works
When enabled, your shop page gains a search bar and product category browsing. Without the storefront channel, your shop page still displays store information, popular products, and policy pages. The storefront integrates with other channels to provide a seamless shopping experience.
	`;

	manageUrl = '/channels/{shopId}/settings/storefront';
	productSpecificVisibility = true;

	worksWith = ['google', 'product-reservations', 'local-checkout', 'meta-commerce'];

	helpArticleUrls = [
		{
			title: 'Customising your storefront',
			url: 'https://support.near.st/en/articles/6675170'
		}
	];

	requirements = new Requirements({});
}

module.exports = StorefrontChannel;
